import apiClient from "@/axios";

export const getAllList = async (page = 1, sort = 'created_at', order = 'asc', platformId = null, searchQuery = null) => {
  const response = apiClient.post("/user/list/app/all", { 
    page: page,
    sort: sort,
    order: order,
    platformId: platformId,
    searchQuery: searchQuery
  });
  return response;
};

export const getAppList = async (appId) => {
  const response = apiClient.post("/user/list/app/app-lists", { appId: appId });
  return response;
};

export const getSavedList = async (appId) => {
  const response = apiClient.post("/user/list/app/saved-lists", {
    appId: appId,
  });
  return response;
};

export const getListApps = async (listId) => {
  const response = apiClient.post("/user/list/app/list-apps", {
    listId: listId,
  });
  return response;
};

export const addAppToList = async (appId, listId) => {
  const response = apiClient.post("/user/list/app/add", {
    appId: appId,
    listId: listId,
  });
  return response;
};

export const AddAppToMultipleLists = async (appId, listIds) => {
  const response = apiClient.post("/user/list/app/add-to-multiple-lists", {
    appId: appId,
    listIds: listIds,
  });
  return response;
};

export const removeAppFromList = async (appId, listId) => {
  const response = apiClient.post("/user/list/app/remove", {
    appId: appId,
    listId: listId,
  });
  return response;
};
